export default class AjandekKonfigurator {

    constructor() {
        this.$kont = $('.ajandekkonfigurator');

        if (this.$kont.length === 0) {
            return;
        }

        this.kategoria = this.$kont.data('kategoria');
        this.bID = this.$kont.data('bid');
        this.userLoggedIn = !!this.$kont.data('user-logged-in');
        this.locale = this.$kont.data('locale') || $('html').data('locale') || 'hu_HU';
        const isDe = this.locale === 'de_DE' || (this.locale && this.locale.indexOf('de') === 0);
        const landingUrlDe = this.$kont.data('landing-url-de');
        this.landingUrl = (isDe && landingUrlDe) ? landingUrlDe : (this.$kont.data('landing-url') || '/ajandekcsomag-kosar');
        this.$dobozok = this.$kont.find('#ajandekkonfigurator-dobozok');
        this.$panel = this.$kont.find('.ajandekkonfigurator-panel');
        this.$action = this.$panel.find('.ajandekkonfigurator-panel-action');
        this.csrfToken = window.keresoCSRFToken || '';
        this._lastHash = null;
        this.szettId = null;
        this.layoutCount = null;
        this.selected = {
            doboz: null,
            cellak: {} // cellaPoz -> { termek_id, nev, type_text, price, club_price, price_szamol, club_price_szamol }
        };

        window.addEventListener('hashchange', () => this.renderFromHash());

        this.bindDarabszam();
        this.bindKosarbtn();
        this.bindVissza();
        this.bindMobileBar();
        this.initActionPlacement();
        this.init();
    }

    bindVissza() {
        const self = this;
        const $vissza = this.$kont.find('.ajandekkonfigurator-step-vissza');
        this.setVissza = (visible) => $vissza.toggleClass('d-none', !visible);
        this.$kont.on('click', '.ajandekkonfigurator-step-vissza', function (e) {
            e.preventDefault();
            self.restoreActionPlacement();
            const p = self.parseHash();
            const $editor = self.$dobozok.find('.ajandekkonfigurator-editor');
            const layoutCount = self.layoutCount !== null && self.layoutCount !== undefined
                ? self.layoutCount
                : ($editor.length && $editor.data('layout-count') !== undefined ? parseInt($editor.data('layout-count'), 10) : null);

            if (p.layout !== undefined) {
                if (layoutCount === 1) {
                    self.resetKonfigurator();
                } else {
                    self.loadLayoutok(p.id, true);
                }
            } else {
                self.resetKonfigurator();
            }
        });
    }

    setStep(step) {
        if (step !== 3) {
            this.restoreActionPlacement();
        }
        this.closeMobilePanel();
        this.$kont.removeClass('step-1 step-2 step-3').addClass('step-' + step).attr('data-step', step);
        const $colBal = this.$kont.find('.ajandekkonfigurator-bal-oszlop');
        const $colJobb = this.$kont.find('.ajandekkonfigurator-jobb-oszlop');
        if (step === 1) {
            $colBal.removeClass('col-7').addClass('col-12');
            $colJobb.addClass('d-none');
        } else {
            $colBal.removeClass('col-12').addClass('col-7');
            $colJobb.removeClass('d-none');
        }
        this.updateActionPlacement();
    }

    bindMobileBar() {
        this.$panel.on('click', '.ajandekkonfigurator-panel-mobile-bar', (e) => {
            e.preventDefault();
            this.toggleMobilePanel();
        });

        this.$kont.on('click', '.ajandekkonfigurator-panel-backdrop', (e) => {
            e.preventDefault();
            this.closeMobilePanel();
        });
    }

    toggleMobilePanel() {
        if (this.$panel.hasClass('is-open')) {
            this.closeMobilePanel();
        } else {
            this.openMobilePanel();
        }
    }

    openMobilePanel() {
        this.$panel.addClass('is-open');
        this.$kont.find('.ajandekkonfigurator-panel-backdrop').removeClass('d-none');
    }

    closeMobilePanel() {
        this.$panel.removeClass('is-open');
        this.$kont.find('.ajandekkonfigurator-panel-backdrop').addClass('d-none');
    }

    bindKosarbtn() {
        this.$kont.on('click', '.ajandekkonfigurator-panel-kosarbtn', (e) => {
            e.preventDefault();
            this.kosarbarak();
        });
    }

    initActionPlacement() {
        const mql = window.matchMedia('(max-width: 991px)');
        const handler = () => this.updateActionPlacement();
        if (mql.addEventListener) {
            mql.addEventListener('change', handler);
        } else if (mql.addListener) {
            mql.addListener(handler);
        }
        window.addEventListener('resize', handler);
    }

    restoreActionPlacement() {
        const $action = (this.$action && this.$action.length) ? this.$action : this.$kont.find('.ajandekkonfigurator-panel-action');
        const $totalRow = this.$panel.find('.ajandekkonfigurator-panel-total-row');
        if ($action.length && $totalRow.length && !$action.prev().is($totalRow)) {
            $totalRow.after($action);
        }
    }

    updateActionPlacement() {
        const $action = (this.$action && this.$action.length) ? this.$action : this.$kont.find('.ajandekkonfigurator-panel-action');
        if (!$action.length) {
            return;
        }

        const isMobile = window.matchMedia('(max-width: 991px)').matches;
        const $kozep = this.$dobozok.find('.ajandekkonfigurator-editor-kozep');
        const isStep3 = this.$kont.hasClass('step-3') || $kozep.length > 0;

        if (isMobile && isStep3 && $kozep.length) {
            if (!$action.parent().is($kozep)) {
                $kozep.append($action);
            }
        } else {
            this.restoreActionPlacement();
        }
    }

    bindDarabszam() {
        const self = this;
        this.$kont.on('click', '.termek-mennyiseg-valaszto .darabszam-input .plus, .termek-mennyiseg-valaszto .darabszam-input .minus', function (e) {
            e.preventDefault();
            const $input = self.$kont.find('.termek-mennyiseg-valaszto .darabszam-input input');
            if (!$input.length) {
                return;
            }
            let db = parseInt($input.val(), 10);
            if (isNaN(db) || db < 1) {
                db = 1;
            }
            db = Math.max(1, db + ($(this).hasClass('plus') ? 1 : -1));
            $input.val(db);
            self.updatePanel();
        });
    }

    init() {
        this.renderFromHash();
    }

    parseHash() {
        const raw = (location.hash || '').replace(/^#/, '');
        const p = {};
        if (raw) {
            new URLSearchParams(raw).forEach((v, k) => {
                p[k] = decodeURIComponent(v);
            });
        }
        return p;
    }

    hashString(p) {
        if (!p || !p.id) {
            return '';
        }
        if (p.layout !== undefined) {
            return 'id=' + p.id + '&layout=' + p.layout;
        }
        return 'id=' + p.id + '&mode=2';
    }

    setHash(p) {
        const h = this.hashString(p);
        if (location.hash.replace(/^#/, '') !== h) {
            location.hash = h;
        }
        this._lastHash = location.hash;
    }

    renderFromHash() {
        const h = location.hash;
        if (h === this._lastHash) {
            return;
        }
        this._lastHash = h;

        const p = this.parseHash();

        if (!p.id) {
            this.resetKonfigurator();
            return;
        }

        if (p.layout !== undefined) {
            this.layoutSelect(p.id, p.layout);
        } else if (p.mode) {
            this.loadLayoutok(p.id);
        }
    }

    loadDobozok() {
        this.setStep(1);
        if (this.setVissza) {
            this.setVissza(false);
        }
        this.$kont.find('.ajandekkonfigurator-step-badge').text('1.');
        this.$kont.find('.ajandekkonfigurator-step-desc')
            .text(this.__('Válassza ki az ajándékdoboz típusát'));
        this.$dobozok.html('<div class="ajandekkonfigurator-loader"><div class="ajandekkonfigurator-spinner"></div></div>');
        window.scrollTo({ top: 0, behavior: 'smooth' });

        $.ajax({
            url: '/index.php/webshoplist_static/gethtml',
            type: 'GET',
            data: {
                kategoria: this.kategoria,
                extra: 'vasarlas|onlyitems|ajandekszerkeszto_frontend',
                nezet: '2024'
            },
            headers: {
                'X-CSRF-Token': this.csrfToken
            },
            success: (response) => {
                if (response.html) {
                    this.renderDobozok(response.html);
                }
            },
            error: () => {
                this.$dobozok.html('<div class="ajandekkonfigurator-error">' + this.__('A termékek betöltése sikertelen.') + '</div>');
            }
        });
    }

    renderDobozok(html) {
        this.$dobozok.html(html);

        this.$dobozok.find('.ajandekkonfigurator-doboz-kivalaszt, .ajandekdoboz .image-wrapper, .ajandekdoboz .title').on('click', (e) => {
            e.preventDefault();
            const $doboz = $(e.currentTarget).closest('.ajandekdoboz');
            this.onDobozSelect($doboz);
        });
    }

    onDobozSelect($doboz) {
        const szettId = $doboz.find('.ajandekkonfigurator-doboz-kivalaszt').data('szett_id');
        this.loadLayoutok(szettId);
    }

    loadLayoutok(szettId, fromVissza = false) {
        this.restoreActionPlacement();
        if (this.setVissza) {
            this.setVissza(true);
        }
        this.$dobozok.html('<div class="ajandekkonfigurator-loader"><div class="ajandekkonfigurator-spinner"></div></div>');

        $.ajax({
            url: '/index.php/webshoplist_static/gethtml',
            type: 'GET',
            data: {
                extra: 'ajandekszerkeszto_frontend',
                mode: 'layout',
                id: szettId
            },
            headers: {
                'X-CSRF-Token': this.csrfToken
            },
            success: (response) => {
                if (!response.html) {
                    return;
                }

                this.layoutCount = response.layout_count;

                if (response.layout_count === 1) {
                    if (fromVissza) {
                        this.resetKonfigurator();
                        return;
                    }
                    const $btn = $(response.html).find('.ajandekkonfigurator-layout-kivalaszt').first();
                    const pozicio = $btn.data('pozicio');
                    this.setHash({ id: szettId, layout: pozicio });
                    this.layoutSelect(szettId, pozicio);
                    return;
                }

                this.setStep(2);
                this.setHash({ id: szettId, mode: 2 });

                this.$kont.find('.ajandekkonfigurator-step-badge').text('2.');
                this.$kont.find('.ajandekkonfigurator-step-desc')
                    .text(this.__('Válassza ki a doboz tartalmát'));

                this.$dobozok.html(response.html);

                this.$dobozok.find('.ajandekkonfigurator-layout-kivalaszt, .ajandekkonfigurator-layout-kep').on('click', (e) => {
                    e.preventDefault();
                    const $card = $(e.currentTarget).closest('.ajandekkonfigurator-layout-kartya');
                    const $btn = $card.find('.ajandekkonfigurator-layout-kivalaszt');
                    this.setHash({ id: $btn.data('szett_id'), layout: $btn.data('pozicio') });
                    this.layoutSelect($btn.data('szett_id'), $btn.data('pozicio'));
                });

                window.scrollTo({ top: 0, behavior: 'smooth' });
            },
            error: () => {
                this.$dobozok.html('<div class="ajandekkonfigurator-error">' + this.__('A layoutok betöltése sikertelen.') + '</div>');
            }
        });
    }

    layoutSelect(szettId, pozicio) {
        this.restoreActionPlacement();
        this.setStep(3);
        if (this.szettId !== null && this.szettId !== szettId) {
            this.selected.cellak = {};
        }
        this.szettId = szettId;
        if (this.setVissza) {
            this.setVissza(true);
        }
        this.$dobozok.html('<div class="ajandekkonfigurator-loader"><div class="ajandekkonfigurator-spinner"></div></div>');

        $.ajax({
            url: '/index.php/webshoplist_static/gethtml',
            type: 'GET',
            data: {
                extra: 'ajandekszerkeszto_frontend',
                mode: 'layout',
                id: szettId,
                layout: pozicio
            },
            headers: {
                'X-CSRF-Token': this.csrfToken
            },
            success: (response) => {
                if (response.html) {
                    if (response.layout_count !== undefined) {
                        this.layoutCount = response.layout_count;
                    }
                    this.$kont.find('.ajandekkonfigurator-step-badge').text('3.');
                    this.$kont.find('.ajandekkonfigurator-step-desc')
                        .text(this.__('Válassza ki a doboz tartalmát'));

                    this.$dobozok.html(response.html);
                    this.initEditor();

                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            },
            error: () => {
                this.$dobozok.html('<div class="ajandekkonfigurator-error">' + this.__('A tartalom betöltése sikertelen.') + '</div>');
            }
        });
    }

    initEditor() {
        this.updateActionPlacement();

        const $editor = this.$dobozok.find('.ajandekkonfigurator-editor').first();
        if ((this.layoutCount === null || this.layoutCount === undefined) && $editor.data('layout-count') !== undefined) {
            this.layoutCount = parseInt($editor.data('layout-count'), 10);
        }
        this.selected.doboz = {
            nev: $editor.data('doboz-nev') || '',
            kep: $editor.data('doboz-kep') || '',
            ar: $editor.data('doboz-ar') || '',
            price: $editor.data('doboz-ar') || '',
            price_szamol: parseFloat($editor.data('doboz-ar-szamol') || 0) || 0,
            club_price_szamol: parseFloat($editor.data('doboz-klub-szamol') || 0) || 0,
            klub: $editor.data('doboz-klub') || '',
            egysegar: $editor.data('doboz-egysegar') || '',
            klubkedv: parseInt($editor.data('doboz-klub-kedv') || 0) || 0,
            klub_van: !!$editor.data('doboz-klub'),
            klublabel: $editor.data('doboz-klublabel') || this.__('Klubár')
        };
        this.renderPanelDoboz();

        this.$dobozok.find('.ajandekkonfigurator-editor-masik-doboz').on('click', (e) => {
            e.preventDefault();
            this.onMasikDoboz();
        });

        this.$dobozok.find('.ajandekkonfigurator-cella-kategoria').on('click', (e) => {
            e.preventDefault();
            const $btn = $(e.currentTarget);
            const $kartya = $btn.closest('.ajandekkonfigurator-cella-kartya');
            $kartya.find('.ajandekkonfigurator-cella-kategoria').removeClass('aktiv');
            $btn.addClass('aktiv');
            this.loadCellaTermekek($kartya, $btn.data('kategoria_id'), $btn.data('kiszereles_ids'), $btn.data('uvegmeret_type'), $btn.data('uvegtipus_ids'));
        });

        this.$dobozok.find('.ajandekkonfigurator-cella-modositom').on('click', (e) => {
            e.preventDefault();
            const $kartya = $(e.currentTarget).closest('.ajandekkonfigurator-cella-kartya');
            const cellaPoz = $kartya.data('cella');
            delete this.selected.cellak[cellaPoz];

            $kartya.removeClass('kitoltve');
            $kartya.find('.ajandekkonfigurator-cella-status').removeClass('selected');
            this.$dobozok.find('.ajk-jelzo[data-cella-jelzo="' + cellaPoz + '"]').removeClass('selected');
            $kartya.find('.ajandekkonfigurator-cella-szerkesztes').removeClass('d-none');
            $kartya.find('.ajandekkonfigurator-cella-kitoltve').addClass('d-none');

            this.updatePanel();
            this.setCellaKartyaZarok();
        });

        this.setCellaKartyaZarok();
        this.updatePanel();
    }

    onMasikDoboz() {
        this.resetKonfigurator();
    }

    loadCellaTermekek($kartya, kategoriaId, kiszerelesIds, uvegmeretType, uvegtipusIds) {
        const $lista = $kartya.find('.ajandekkonfigurator-cella-termeklista');
        $lista.attr('data-kategoria_id', kategoriaId);
        $lista.html('<div class="ajandekkonfigurator-loader"><div class="ajandekkonfigurator-spinner"></div></div>');

        $.ajax({
            url: '/index.php/webshoplist_static/gethtml',
            type: 'GET',
            data: {
                extra: 'ajandekszerkeszto_frontend',
                mode: 'cell_termekek',
                kategoria_id: kategoriaId,
                kiszereles_ids: kiszerelesIds || '',
                uvegmeret_type: uvegmeretType || 1,
                uvegtipus_ids: uvegtipusIds || ''
            },
            headers: { 'X-CSRF-Token': this.csrfToken },
            success: (response) => {
                if (!response.html) {
                    return;
                }
                $lista.html(response.html);
                this.bindCellaTermekLista($kartya);
            },
            error: () => {
                $lista.html('<div class="ajandekkonfigurator-cella-nincs">' + this.__('A termékek betöltése sikertelen.') + '</div>');
            }
        });
    }

    bindCellaTermekLista($kartya) {
        const self = this;

        const $aktiv = null;
        $kartya.find('.ajandekkonfigurator-cella-termek').each(function () {
            const $termek = $(this);
            const $kiszsor = $termek.find('.ajandekkonfigurator-cella-termek-kiszerelesek');
            if (!$kiszsor.length) {
                return;
            }
            const $elso = $kiszsor.find('.ajandekkonfigurator-cella-termek-kisz').first();
            $termek.find('.ajandekkonfigurator-cella-termek-kisz').removeClass('aktiv');
            $elso.addClass('aktiv');
            $termek.find('.ajandekkonfigurator-cella-termek-plusz').removeClass('inaktiv').prop('disabled', false);
            $termek.find('.ajandekkonfigurator-cella-termek-nev-kiszereles').text('– ' + ($elso.data('type-text') || ''));
            self.renderKiszAr($termek, $elso);
        });

        $kartya.find('.ajandekkonfigurator-cella-termek-kisz').on('click', function () {
            const $szulo = $(this).closest('.ajandekkonfigurator-cella-termek');
            $szulo.find('.ajandekkonfigurator-cella-termek-kisz').removeClass('aktiv');
            $(this).addClass('aktiv');
            $szulo.find('.ajandekkonfigurator-cella-termek-plusz').removeClass('inaktiv').prop('disabled', false);
            $szulo.find('.ajandekkonfigurator-cella-termek-nev-kiszereles').text('– ' + ($(this).data('type-text') || ''));
            self.renderKiszAr($szulo, $(this));
        });

        $kartya.find('.ajandekkonfigurator-cella-termek-plusz').on('click', function () {
            const $termek = $(this).closest('.ajandekkonfigurator-cella-termek');
            const $aktivKisz = $termek.find('.ajandekkonfigurator-cella-termek-kisz.aktiv');
            const $ar = $termek.find('.ajandekkonfigurator-cella-termek-ar');
            const kep = $termek.find('.ajandekkonfigurator-cella-termek-kep img').attr('src') || '';

            const pick = (src) => ({
                kiszereles_id: src.data('kiszereles_id') != null ? src.data('kiszereles_id') : src.data('ki'),
                type_text: src.data('type-text'),
                price: src.data('price'),
                club_price: src.data('club-price'),
                klub: src.data('club-price'),
                price_szamol: parseFloat(src.data('price-szamol')) || 0,
                club_price_szamol: parseFloat(src.data('club-price-szamol')) || 0,
                egysegar: src.data('egysegar') || '',
                klubkedv: parseInt(src.data('klubkedv')) || 0,
                klub_van: !!src.data('klub-van')
            });

            const adat = $aktivKisz.length ? pick($aktivKisz) : pick($ar);
            adat.kep = kep;
            adat.termek_id = $termek.data('termek_id');
            adat.nev = $termek.data('termek_nev');
            adat.klublabel = $termek.data('klublabel') || this.__('Klubár');
            if (adat.type_text) {
                adat.nev = adat.nev + ' - ' + adat.type_text;
            }

            self.selectCellaTermek($kartya.data('cella'), adat);
        });
    }

    renderKiszAr($szulo, $btn) {
        const $arKont = $szulo.find('.ajandekkonfigurator-cella-termek-ar');
        const ar = $btn.data('price') || '';
        const clubAr = $btn.data('club-price') || '';
        const egysegar = $btn.data('egysegar') || '';
        const kedv = parseInt($btn.data('klubkedv')) || 0;
        const klubVan = $btn.data('klub-van') == 1;
        const klublabel = $szulo.data('klublabel') || this.__('Klubár');

        const $webshop = $arKont.find('.ajandekkonfigurator-cella-termek-ar-webshop');
        $webshop.html(this.__('Webshop ár') + ': ' + ar);
        if (egysegar) {
            $webshop.append(' <span class="ajandekkonfigurator-cella-termek-egysegar">(' + egysegar + ')</span>');
        }

        let $klub = $arKont.find('.ajandekkonfigurator-cella-termek-ar-klub');
        if (klubVan && clubAr) {
            if (!$klub.length) {
                $klub = $('<span class="ajandekkonfigurator-cella-termek-ar-klub"></span>');
                $arKont.append($klub);
            }
            $klub.html(klublabel + (kedv > 0 ? ' -' + kedv + '%' : '') + ': <strong>' + clubAr + '</strong>');
        } else {
            $klub.remove();
        }
    }

    clearCella(cellaPoz) {
        delete this.selected.cellak[cellaPoz];
        const $kartya = this.$dobozok.find('.ajandekkonfigurator-cella-kartya[data-cella="' + cellaPoz + '"]');
        $kartya.removeClass('kitoltve');
        $kartya.find('.ajandekkonfigurator-cella-status').removeClass('selected');
        this.$dobozok.find('.ajk-jelzo[data-cella-jelzo="' + cellaPoz + '"]').removeClass('selected');
        $kartya.find('.ajandekkonfigurator-cella-szerkesztes').removeClass('d-none');
        $kartya.find('.ajandekkonfigurator-cella-kitoltve').addClass('d-none');
    }

    setCellaKartyaZarok() {
        const $kartyak = this.$dobozok.find('.ajandekkonfigurator-cella-kartya');
        let firstGapSeen = false;
        $kartyak.each((i, el) => {
            const $k = $(el);
            const poz = parseInt($k.data('cella'), 10);
            const kitoltve = !!this.selected.cellak[poz];
            if (!kitoltve) {
                if (firstGapSeen) {
                    $k.addClass('inaktiv');
                } else {
                    $k.removeClass('inaktiv');
                    firstGapSeen = true;
                }
                return;
            }
            $k.removeClass('inaktiv');
        });
        this.autoInitAktivKartyak();
    }

    autoInitAktivKartyak() {
        const self = this;
        this.$dobozok.find('.ajandekkonfigurator-cella-kartya').each(function () {
            const $k = $(this);
            const $kategoriaSor = $k.find('.ajandekkonfigurator-cella-kategoria-sor');
            const $gombok = $kategoriaSor.find('.ajandekkonfigurator-cella-kategoria');
            const inaktiv = $k.hasClass('inaktiv');

            if (inaktiv) {
                $kategoriaSor.addClass('d-none');
                return;
            }
            $kategoriaSor.removeClass('d-none');
            if ($gombok.length === 1) {
                $kategoriaSor.addClass('d-none');
            }
            const $aktiv = $k.find('.ajandekkonfigurator-cella-kategoria.aktiv');
            const $lista = $k.find('.ajandekkonfigurator-cella-termeklista');
            if ($aktiv.length === 0 && $gombok.length > 0) {
                const $elso = $gombok.first();
                $gombok.removeClass('aktiv');
                $elso.addClass('aktiv');
                if (!$lista.children().length || $lista.data('kategoria_id') === '') {
                    self.loadCellaTermekek($k, $elso.data('kategoria_id'), $elso.data('kiszereles_ids'), $elso.data('uvegmeret_type'), $elso.data('uvegtipus_ids'));
                }
            }
        });
    }

    selectCellaTermek(cellaPoz, adat) {

        this.selected.cellak[cellaPoz] = adat;

        console.log('Cella kiválasztva:', this.selected.cellak);
        const $kartya = this.$dobozok.find('.ajandekkonfigurator-cella-kartya[data-cella="' + cellaPoz + '"]');
        $kartya.addClass('kitoltve');
        $kartya.find('.ajandekkonfigurator-cella-szerkesztes').addClass('d-none');
        $kartya.find('.ajandekkonfigurator-cella-kitoltve').removeClass('d-none');
        $kartya.find('.ajandekkonfigurator-cella-kitoltve-nev').text(adat.nev);
        $kartya.find('.ajandekkonfigurator-cella-status').addClass('selected');
        this.$dobozok.find('.ajk-jelzo[data-cella-jelzo="' + cellaPoz + '"]').addClass('selected');

        this.updatePanel();
        this.setCellaKartyaZarok();
    }

    panelSor(adat, cls, db) {
        const darab = (typeof db === 'number' && db > 1) ? db : 1;
        const $row = $('<div class="' + cls + '">');
        if (adat.kep) {
            $row.append('<div class="ajandekkonfigurator-panel-kep">' +
                '<div class="ajandekkonfigurator-panel-kep-img"><img src="' + adat.kep + '" alt="" /></div>' +
                (darab > 1 ? '<span class="ajandekkonfigurator-panel-badge">' + darab + '</span>' : '') +
                '</div>');
        }
        const $main = $('<div class="ajandekkonfigurator-panel-main">');
        const $info = $('<div class="ajandekkonfigurator-panel-main-info">');
        $info.append($('<div class="ajandekkonfigurator-panel-nev">').text(adat.nev));
        $main.append($info);

        const vanKlub = this.userLoggedIn && adat.klub_van && adat.klub;
        const klublabel = adat.klublabel || this.__('Klubár');

        const $ar = $('<div class="ajandekkonfigurator-panel-ar">');
        if (vanKlub) {
            const kedv = adat.klubkedv > 0 ? ' -' + adat.klubkedv + '%' : '';
            $ar.append($('<div class="ajandekkonfigurator-panel-klub-cim">' + klublabel + '<span class="ajandekkonfigurator-panel-klub-kedv">' + kedv + '</span></div>'));
            $ar.append($('<div class="ajandekkonfigurator-panel-klub-ar">').html(this.multiAr(adat, darab)));
        } else {
            $ar.append($('<div class="ajandekkonfigurator-panel-klub-ar">').html(this.multiAr(adat, darab)));
        }
        $main.append($ar);
        $row.append($main);
        return $row;
    }

    multiAr(adat, darab) {
        const vanKlub = this.userLoggedIn && adat.klub_van && adat.klub;
        const szamol = this.arSzamol(adat);
        if (darab > 1 && szamol > 0) {
            return this.formatPrice(szamol * darab);
        }
        return vanKlub ? adat.klub : adat.price;
    }

    arSzamol(adat) {
        const vanKlub = this.userLoggedIn && adat.klub_van && adat.klub;
        return ((vanKlub ? adat.club_price_szamol : adat.price_szamol) || adat.price_szamol || 0);
    }

    updatePanel() {
        const cellak = Object.values(this.selected.cellak);
        const $termekek = this.$panel.find('.ajandekkonfigurator-panel-termekek');
        $termekek.empty();

        const $darab = this.$kont.find('.darabszam-input input');
        const db = $darab.length ? (parseInt($darab.val(), 10) || 1) : 1;

        let sum = 0;
        if (this.selected.doboz) {
            sum += this.arSzamol(this.selected.doboz) * db;
            this.$panel.find('.ajandekkonfigurator-panel-doboz').html(this.panelSor(this.selected.doboz, 'ajandekkonfigurator-panel-doboz-sor', db));
        }
        cellak.forEach((c) => {
            sum += this.arSzamol(c) * db;
            $termekek.append(this.panelSor(c, 'ajandekkonfigurator-panel-termek-sor', db));
        });

        this.$panel.find('[data-total]').text(this.formatAr(cellak, sum));

        const kitoltve = Object.keys(this.selected.cellak).length;
        const cellakSzama = this.$dobozok.find('.ajandekkonfigurator-cella-kartya').length;
        const kesz = cellakSzama > 0 && kitoltve >= cellakSzama;

        const $kosarbtn = this.$kont.find('.ajandekkonfigurator-panel-kosarbtn');
        $kosarbtn.prop('disabled', !kesz);

        const $dbkont = this.$kont.find('.termek-mennyiseg-valaszto');
        $dbkont.toggleClass('disabled', !kesz);

        const hasDoboz = !!this.selected.doboz;
        const hasTermek = cellak.length > 0;
        this.$panel.toggleClass('has-doboz', hasDoboz);
        this.$panel.toggleClass('has-termek', hasTermek);
        this.$panel.toggleClass('is-empty', !hasDoboz && !hasTermek);
        this.$panel.find('.ajandekkonfigurator-panel-total-row')
            .toggleClass('disabled', !hasDoboz && !hasTermek);

        console.log('Panel frissítve, kitöltve:', kitoltve, 'összesen:', cellakSzama, this.selected);
    }

    kosarbarak() {
        const $kosarbtn = this.$kont.find('.ajandekkonfigurator-panel-kosarbtn');
        if (!this.szettId || this._kosarbarakBusy || $kosarbtn.prop('disabled')) {
            return;
        }
        this._kosarbarakBusy = true;
        $kosarbtn.prop('disabled', true);

        console.log('ad', this.selected);

        const items = Object.values(this.selected.cellak).map((c) => ({
            termek_id: c.termek_id,
            kiszereles_id: c.kiszereles_id || 0,
            db: 1
        }));

        const $darab = this.$kont.find('.darabszam-input input');
        const db = $darab.length ? parseInt($darab.val(), 10) : 1;

        const datas = {
            mode: 'ajandekkonfigurator',
            szett_id: this.szettId,
            szett_csomag: 1,
            db_14: db > 0 ? db : 1,
            pontbevaltas: 0,
            items: items
        };

        $.ajax({
            url: '/kosar/ad',
            type: 'POST',
            data: datas,
            headers: { 'X-CSRF-Token': this.csrfToken },
            success: (res) => {
                if (res && res.kos && res.kos.allproduct) {
                    $('.webshop-button-d2 .cart-num').text(res.kos.allproduct);
                    $('#kosarlink1 .amount, #kosarlink2 .amount, .header .tools .shop .amount').each(function () {
                        $(this).text(res.kos.allproduct);
                        if (+res.kos.allproduct > 9) {
                            $(this).addClass('wider');
                        }
                    });
                }
                this.addKosarAnimacio();
            },
            error: () => {
                this._kosarbarakBusy = false;
                $kosarbtn.prop('disabled', false);
            }
        });
    }

    addKosarAnimacio() {
        const cart = $('.webshop-button-d2').length ? $('.webshop-button-d2') : $('#kosarlink1').first();
        if (!cart.length) {
            window.location.href = this.landingUrl;
            return;
        }

        const $btn = this.$kont.find('.ajandekkonfigurator-panel-kosarbtn');
        const to = cart.offset() || { top: 0, left: 0 };
        const from = $btn.offset() || { top: 0, left: 0 };

        const klon = $btn.clone()
            .addClass('ajk-kosar-klon')
            .css({
                position: 'absolute',
                top: from.top,
                left: from.left,
                'z-index': 1000,
                opacity: 0.5
            })
            .appendTo($('body'));

        klon.animate({
            top: to.top + 10,
            left: to.left + 30
        }, 500, 'swing', () => {
            klon.remove();
            window.location.href = this.landingUrl;
        });
    }

    resetKonfigurator() {
        this.restoreActionPlacement();
        this.closeMobilePanel();
        this.szettId = null;
        this.layoutCount = null;
        this.selected.doboz = null;
        this.selected.cellak = {};
        this.$panel.find('.ajandekkonfigurator-panel-doboz').empty();
        this.$panel.find('.ajandekkonfigurator-panel-termekek').empty();
        this.$kont.find('.darabszam-input input').val('1');
        this.updateActionPlacement();
        this.updatePanel();
        this.setHash({});
        this.loadDobozok();
    }

    formatAr(cellak, szamol) {
        return this.formatPrice(szamol);
    }

    formatFt(szamol) {
        return this.formatPrice(szamol);
    }

    formatPrice(value) {
        const locale = this.locale || this.$kont.data('locale') || $('html').data('locale') || 'hu_HU';
        const num = Number(value) || 0;

        if (locale === 'hu_HU') {
            return this.numberFormat(num, 0, '.', ' ') + ' ' + this.__('Ft');
        } else if (locale === 'de_DE' || locale === 'sk_SK' || locale === 'sl_SI' || locale === 'en_EU') {
            return this.numberFormat(num, 2, ',', '.') + ' €';
        } else if (locale === 'fr_FR' || locale === 'fr_BE') {
            const t = this.numberFormat(num, 2, ',', '.') + ' €';
            return t.replace(',00', '');
        } else if (locale === 'cs_CZ') {
            return this.numberFormat(num, 0, ',', ' ') + ' Kč';
        } else if (locale === 'pl_PL') {
            return this.numberFormat(num, 2, ',', ' ') + ' zł';
        } else if (locale === 'en_US' || locale === 'en_AU') {
            return '$' + this.numberFormat(num, 2, '.', ',');
        } else {
            return this.numberFormat(num, 2, ',', '.') + ' €';
        }
    }

    numberFormat(number, decimals, decPoint, thousandsSep) {
        if (window.Kosar && typeof window.Kosar.number_format === 'function') {
            return window.Kosar.number_format(number, decimals, decPoint, thousandsSep);
        }
        const n = !isFinite(+number) ? 0 : +number;
        const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
        const sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
        const dec = typeof decPoint === 'undefined' ? '.' : decPoint;
        const toFixedFix = (val, p) => {
            const k = Math.pow(10, p);
            return '' + (Math.round(val * k) / k).toFixed(p);
        };
        const s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }

    renderPanelDoboz() {
        const $doboz = this.$panel.find('.ajandekkonfigurator-panel-doboz');
        $doboz.empty();
        if (!this.selected.doboz || !this.selected.doboz.nev) {
            return;
        }
        const $darab = this.$kont.find('.darabszam-input input');
        const db = $darab.length ? (parseInt($darab.val(), 10) || 1) : 1;
        $doboz.append(this.panelSor(this.selected.doboz, 'ajandekkonfigurator-panel-doboz-sor', db));
    }

    __(text) {
        const lng = window.ajandekKonfiguratorLng || {};
        return lng[text] || text;
    }
}
